import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["instructions"]
  static values = {
    force: Boolean,
    surface: String
  }

  connect() {
    this.refresh = this.refresh.bind(this)
    this.trackInstalled = this.trackInstalled.bind(this)
    window.addEventListener("rafa:pwa-install-state", this.refresh)
    window.addEventListener("rafa:pwa-installed", this.trackInstalled)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("rafa:pwa-install-state", this.refresh)
    window.removeEventListener("rafa:pwa-installed", this.trackInstalled)
  }

  refresh() {
    const state = window.rafaPwaInstall?.state({ ignoreSnooze: this.forceValue })
    const shouldShow = Boolean(state?.eligible)
    this.element.classList.toggle("hidden", !shouldShow)
    this.platform = state?.platform

    if (shouldShow && !this.hasTrackedShown) {
      this.hasTrackedShown = true
      this.track("shown")
    }
  }

  async install() {
    if (this.platform === "ios") {
      this.instructionsTarget.classList.remove("hidden")
      this.track("instructions_shown")
      return
    }

    const result = await window.rafaPwaInstall?.request()
    this.track(result?.outcome === "accepted" ? "accepted" : "dismissed")
  }

  dismiss() {
    window.rafaPwaInstall?.snooze()
    this.track("dismissed")
  }

  installed() {
    window.rafaPwaInstall?.markInstalled()
    this.track("installed")
  }

  trackInstalled() {
    this.track("installed")
  }

  track(action) {
    const url = document.body.dataset.eventsUrl
    if (!url) return

    post(url, {
      responseKind: "json",
      body: {
        event_class: "PwaInstallationChanged",
        action_name: action,
        platform_name: this.platform || "unknown",
        surface: this.surfaceValue
      }
    })
  }
}
